/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import { AdvantageAbout, Managers, OurStoryD } from "json/landingPageData";
import Header1 from "parts/Header1";
import AdvangeAbout from "parts/AdvangeAbout";
import OurStory from "parts/Ourstory";
import TeamSection from "parts/TeamSection";
import TeamGroup from "parts/TeamGroup";
import CtaAbout from "parts/CtaAbout";
import Footer from "parts/Footer";

export default class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>About Us | Nube iO – Proudly Australian, Smart Building Technology</title>
          <meta
            name="description"
            content="Nube iO is an Australian company building smarter, simpler building automation — from hardware and software to the team behind every deployment."
          />
          <meta
            name="keywords"
            content="Nube iO story, Australian building automation company, smart building technology"
          />
          <link rel="canonical" href="https://nube-io.com/our-story/" />
          <meta
            property="og:title"
            content="About Us | Nube iO – Proudly Australian, Smart Building Technology"
          />
          <meta
            property="og:description"
            content="Nube iO is an Australian company building smarter, simpler building automation — from hardware and software to the team behind every deployment."
          />
          <meta property="og:url" content="https://nube-io.com/our-story/" />
        </Helmet>

        <Header1 />
        <OurStory data={OurStoryD} />
        <AdvangeAbout data={AdvantageAbout} />
        <TeamGroup />
        <TeamSection data={Managers} />
        <CtaAbout />
        <Footer />
      </>
    );
  }
}
